import React from "react";
import {Link} from "react-router-dom";
import classNames from "classnames";

import ReactTable from "react-table";
import {Button} from "reactstrap";
import ClipLoader from 'react-spinners/ClipLoader';
import {Card, CardContent} from "@material-ui/core";
import Select from "react-select";

import API from "@beardeddevops/react.api";
import APPCONFIG from "../../constants/Config";
import Framework from "@beardeddevops/react.framework";
import Types from 'constants/Types';

import moment from "moment";

const STATUS_LABELS = {
	0: "Open",
	1: "Paid",
	2: "Written Off",
};

const STATUS_OPTIONS = [
	{value: null, label: 'All Statuses'},
	{value: 0, label: 'Open'},
	{value: 1, label: 'Paid'},
	{value: 2, label: 'Written Off'},
];

export default class Invoices extends Framework.Components.Collection {
	constructor(props) {
		let model = new API.BuildClass(Types.Invoices._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state.limit = 16;
		this.limit = 16;
		this.state.invoiceStatus = STATUS_OPTIONS[0];
		this.state.filter = {};
		this.tableState = null;
	}

	defaultTableState = () => ({
		page: 0,
		pageSize: this.state.limit,
		sorted: [{
			id: this.model.sort,
			desc: this.model.order === 'desc',
		}],
		filtered: [],
	});

	fetchInvoicesData = (tableState) => {
		this.tableState = tableState;
		this.fetchData(tableState);
	};

	handleStatusFilter = (option) => {
		const filter = {...(this.state.filter || {})};
		if (option && option.value != null) {
			filter.invoice_status = option.value;
		} else {
			delete filter.invoice_status;
		}
		this.state.filter = filter;
		this.setState({invoiceStatus: option || STATUS_OPTIONS[0], filter}, () => {
			if (typeof this.fetchData === 'function') {
				this.fetchData(this.tableState || this.defaultTableState());
			}
		});
	};

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = [
			{
				Header: "Created Date",
				id: "created",
				className: 'center-column',
				accessor: obj => obj.created ? moment(obj.created).local().format("MM/DD/YYYY") : '-'
			},
			{
				Header: "Customer",
				id: "client",
				className: 'center-column',
				accessor: obj => obj.customers ? obj.customers.name : obj.client
			},
			{
				Header: "Transaction Total",
				id: "amount",
				className: 'center-column',
				accessor: r => "$" + parseFloat(r.amount ?? 0).toFixed(2)
			},
			{
				Header: "Invoiced",
				id: "invoice_amount",
				className: 'center-column',
				accessor: r => "$" + parseFloat(r.invoice_amount ?? 0).toFixed(2)
			},
			{
				Header: "Remaining",
				id: "invoice_remaining",
				className: 'center-column',
				accessor: r => "$" + parseFloat(r.invoice_remaining ?? 0).toFixed(2)
			},
			{
				Header: "Status",
				id: "invoice_status",
				className: 'center-column',
				accessor: r => STATUS_LABELS[parseInt(r.invoice_status)] ?? '-'
			},
			{
				Header: "",
				className: "button-cell",
				filterable: false,
				sortable: false,
				width: 60,
				Cell: props => (
					<span>
						<Link to={`/invoices/` + props.original.pkey}>
							<Button className="primary-button" size={"sm"} block={true} style={{ marginTop: '6px' }}>View</Button>
						</Link>
					</span>
				)
			},
		];
		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch("Invoices")}
							<div className="statusFilter" style={{width: '200px', marginLeft: 8}}>
								<Select
									styles={this.customStyles}
									className={classNames('basic-single', {hasSelection: this.state.filter?.invoice_status != null})}
									classNamePrefix="select"
									onChange={this.handleStatusFilter}
									value={this.state.invoiceStatus}
									isClearable={false}
									isSearchable={false}
									name="invoice_status"
									placeholder={"Filter Status"}
									options={STATUS_OPTIONS}
								/>
							</div>
							{this.renderHeaderRight("Invoices", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchInvoicesData}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined
						}}
						defaultSorted={[
							{
								id: this.model.sort,
								desc: this.model.order === 'desc'
							}
						]}
						showPagination={true}
						showPaginationTop={false}
						showPaginationBottom={true}
						showPageSizeOptions={true}
						defaultPageSize={limit}
						onPageSizeChange={this.onPageSizeChange}
						className="-striped -highlight"
						minRows={0}
					/>
				</CardContent>
				{APPCONFIG.settings.isDev() ? null :
					<div className={classNames("tabled", "loader", {'active': loading})}>
						<ClipLoader color={"#4A4A4A"} loading={loading}/>
					</div>
				}
			</Card>
		)
	}
}
